<template>
    <div class="qa-login">
        <img style="position: absolute;bottom: 0;width: 1000px;" src="../assets/images/login-bj1.gif" >
		<img style="position: absolute;right: 0;width: 30%;" src="../assets/images/login-bj-ys1.png" >
		<div style="padding: 40px 0 0 60px;">
			<div style="display: flex;align-items: center;">
				<!-- <img  style="height: 80px;" src="../assets/images/log.png" > -->
				<!-- <span style="margin: 0 20px;background-color: #fff; width: 3px;height: 60px;"></span> -->
				<span style="font-size: 34px;color: #fff;">智慧票务管理系统</span>
			</div>
		</div>
		<div class="qa-form">
			<div class="">欢迎登录~</div>
			<div class="qa-form-title">系统管理员</div>
			<div style="margin: 30px 0 0 0;">
				<a-input placeholder="请输入用户名" v-model="form.staffAccount" @keyup.enter="apiStaffPclogin" />
				<a-input-password placeholder="请输入登录密码" v-model="form.staffPwd" @keyup.enter="apiStaffPclogin" />
				<div style="width: 100%;display: flex;">
					<a-input placeholder="验证码" v-model="form.captchaCode" @keyup.enter="apiStaffPclogin" />
					<img style="margin: 20px 0 0 10px;width: 100px;" @click="apiCaptchaImage" :src="captchaImage" >
				</div>
				<a-button style="width: 100%;margin-top: 40px;" type="primary" @click="apiStaffPclogin" >登录</a-button>
				<div style="text-align: center;margin: 10px 0 0px 0;color: #9e9e9e;">
					{{iniParam.ICP}}
				</div>
			</div>
        </div>
		<div class="qa-foot">
			<!-- 技术支持：秦昂科技 -->
		</div>
    </div>

</template>

<script>
    export default {
		data() {
			return {
				form: {
					staffAccount: '',
					staffPwd: '',
					captchaCode: ''
				},
				iniParam: {
					ICP: '',
				},
				captchaImage: ''
			}
		},
		created() {
			this.apiCaptchaImage()
			this.apiGetLoginParm()
		},
		methods: {
			async apiCaptchaImage(){
				//获取验证码
				const {data: res} = await this.$http.post(this.navigation.apiCaptchaImage);
				if(res.code == 200){
					this.captchaImage = res.data.img
				}else{
					this.$message.error(res.msg);
				}
			},
			async apiStaffPclogin(){
				//登录逻辑
				const {data: res} = await this.$http.post(this.navigation.apiStaffPclogin, this.form);
				if(res.code == 200){
					window.sessionStorage.setItem('staffAccount', this.form.staffAccount)
					window.sessionStorage.setItem('staffId', res.data.staffId)
					window.sessionStorage.setItem('token', res.data.token)
					window.sessionStorage.setItem('positions', res.data.positions)
					this.$message.success(res.msg);
					this.$router.push('/Home')
				}else{
					this.apiCaptchaImage()
					this.$message.error(res.msg);
				}
			},
			async apiGetLoginParm(){
				//登录逻辑
				const {data: res} = await this.$http.post(this.navigation.apiGetLoginParm, this.form);
				if(res.code == 200){
					this.iniParam.ICP = res.data.ICP
				}
			}
	
		}
	}
</script>
<style  lang="less" scoped>
    .qa-login {
        background-image: url(../assets/images/login-background.jpg);
        height: 100%;
        position: relative;
        /* background-repeat: no-repeat;
        background-size:cover; */
    }
    .qa-form{
		padding: 30px;
        background-color: #fff;
        width: 340px;
        position: absolute;
        right: 20%;
        top: calc(50% - 220px);
        border-radius: 6px;
		box-shadow: 0 0 4px #bae7ff;
    }
	.qa-form-title{
		font-size: 25px;
		/* text-align: center; */
		/* width: 100%; */
		font-weight: 550;
		color: #0aa2e5;
	}
	.ant-input{
		margin-top: 20px;
	}
	.ant-input-password{
		margin-top: 20px;
	}
	.qa-foot{
		position: absolute;
		right: 6px;
		bottom: 6px;
		color: #e6f7ff;
	}
</style>
